import { usePermissions } from "@/hooks/usePermissions";
import {
  ORG_PERMISSIONS,
  WORKSPACE_PERMISSIONS,
} from "@/constants/permissions";

export function useCanViewConversationCosts(groupId?: string): boolean {
  const { hasPermission } = usePermissions(groupId);
  return (
    hasPermission(WORKSPACE_PERMISSIONS.ANALYTICS, "group") ||
    hasPermission(ORG_PERMISSIONS.ORG.ADMIN, "tenant")
  );
}
